export default {
    getAllCreateSchedule: [],

    status:[
       { status:'Initialized', value: 1 },
       { status:'In-progress', value: 2 },
       { status:'Completed', value: 3 },
    ],

    
    

    
}